export const GET_BAGDONATIONS = "GET_BAGDONATIONS";
export const TOTAL_BAGDONATIONS = "TOTAL_BAGDONATIONS";
export const ADD_BAGDONATION = "ADD_BAGDONATION";
export const EDIT_BAGDONATION = "EDIT_BAGDONATION";
export const GET_BAGDONATION = "GET_BAGDONATION";
export const RESET_BAGDONATION = "RESET_BAGDONATION";
export const BAGDONATIONS_ERROR = "BAGDONATIONS_ERROR";